import { createFileRoute } from "@tanstack/react-router";
import {
  VakantiesRouteDialog,
  vakantiesRouteOptions,
} from "#/modules/les.planning/vakanties-route";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/week/rooster/vakanties",
)({ ...vakantiesRouteOptions, component: Vakanties });

function Vakanties() {
  const navigate = Route.useNavigate();
  return (
    <VakantiesRouteDialog
      params={Route.useParams()}
      onClose={() =>
        void navigate({
          to: "..",
          search: (prev) => prev,
          replace: true,
          resetScroll: false,
          viewTransition: true,
        })
      }
    />
  );
}
